@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto

object ConfirmVoiceAssistantRouteEndpoint :
    EndPoint<ConfirmVoiceAssistantRouteEndpoint.Request, ConfirmVoiceAssistantRouteEndpoint.Response>() {
    class Request(
        val sessionId: String,
        val pickup: LocationPointDto,
        val dropoff: LocationPointDto,
    )

    class Response(
        val isAccepted: Boolean,
        val message: String?,
    )
}
